import type { ReactFlowInstance } from 'reactflow';
import type { CustomNode, CustomEdge, CustomNodeData } from '@src/components/custom-nodes/types';
import {
  getNearestNodeByType,
  getNodesBetween,
  recalculateHandlePositions,
  createDirectedEdge,
  getIfBranchNode,
} from '@src/scenario-editor/render-utils';
import { recalculateNodesXPos } from '@src/scenario-editor/utils';

interface ReturnAddStatementBranch {
  updatedNodes: CustomNode[];
  updatedEdges: CustomEdge[];
}
export const addStatementBranch = (instance: ReactFlowInstance, node: CustomNode): ReturnAddStatementBranch => {
  const nodes = instance.getNodes() as CustomNode[];
  const edges = instance.getEdges() as CustomEdge[];
  const nodeBranchIndexPosition = node.branchId.split('-').length;

  const startNode = node;
  const endNode = getNearestNodeByType(nodes, edges, node, 'IfCloseNode')!;

  const nodesBetween = getNodesBetween(nodes, edges, startNode, endNode);
  const nodesGroupedByBranch= nodesBetween.reduce((acc: Record<string, CustomNode[]>, node) => {
    const branchIndex = node.branchId.split('-')[nodeBranchIndexPosition];
    acc[branchIndex] = acc[branchIndex] ?? [];
    acc[branchIndex].push(node);
    return acc;
  }, {});

  const newNodeInstance = getIfBranchNode({
    reactFlowInstance: instance,
    position: node.position,
    title: (node.data as CustomNodeData).title,
    branchIndex: Object.keys(nodesGroupedByBranch).length + 1,
    parentNodeId: node.id,
    parentBranchId: node.branchId,
  });

  const updatedNodes = nodes.concat(newNodeInstance);
  recalculateNodesXPos(updatedNodes, undefined, { instance });
  recalculateHandlePositions(updatedNodes, edges);

  let updatedEdges: CustomEdge[] = edges;

  if (nodesBetween.length === 0) {
    updatedEdges = edges.filter((edge) => edge.source !== startNode.id);
  }

  updatedEdges = updatedEdges
    .concat(createDirectedEdge(startNode.id, newNodeInstance.id))
    .concat(createDirectedEdge(newNodeInstance.id, endNode.id))

  return {
    updatedNodes,
    updatedEdges,
  };
}
